import React from "react";
import { PhosphorMagnifyingGlass } from "./PhosphorIcon";
import { InputBase } from "./formInputs/InputBase";

interface Props {
  value: string
  onChange: (value: string) => void
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void

  isLoading?: boolean
  placeholder?: string
  focusOnMount?: boolean
  hasError?: boolean
  maxLength?: number
}

export const SearchInput = (props: Props) => {
  return <InputBase
    clearable
    onClear={() => props.onChange("")}
    error={props.hasError}
    placeholder={props.placeholder}
    onKeyDown={props.onKeyDown}
    onChange={props.onChange}
    rightComponent={{
      position: "left",
      type: "icon",
      icon: <PhosphorMagnifyingGlass />,
    }}
    loading={props.isLoading}
    // Some pickers start their keyword as undefined, which would show the clear button on an empty field
    value={props.value ?? ""}
    maxLength={props.maxLength}
    focusOnMount={props.focusOnMount}
  />
}